import { http } from '@/providers/apis/http';
import { portfolioSerializer } from '@/providers/serializers/portfolio/portfolio';
import { PortfolioContent } from '@/models/portfolio/portfolio-content';
import { analyticSerializer } from '@/providers/serializers/analytic/analytic';
export class PortfolioAPI {

  private static INSTANCE = new PortfolioAPI();

  static get instance() {
    return this.INSTANCE;
  }

  private portfolioNamespace: string = 'api/ds/users/v2';
  private portfolioNamespaceV3: string = 'api/ds/users/v3';
  private identifierNamespace: string = 'api/nucleus/v2';


  public fetchPortfolioContents<T>(
    requestParams: any = {},
    contentBase: string = 'content',
  ): Promise<PortfolioContent[]> {
    const endpoint = `${this.portfolioNamespace}/${contentBase}/portfolio/items`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, requestParams).then((response) => {
      return portfolioSerializer.serializePortfolioContents(response.data, requestParams.activityType);
    });
  }


  public fetchContentSummary(params: {userId: string, itemId: string, sessionId: string, contentSource: string},
                             contentType= 'collection') {
    const endpoint = `${this.portfolioNamespace}/content/portfolio/${contentType}/summary`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params).then((repsonse) => {
        return analyticSerializer.serializeActivityPerformance(repsonse.data);
    });
  }

  public fetchPortfolioStatsBySubject(requestParams: object = {}) {
    const endpoint = `${this.portfolioNamespace}/learner/portfolio/stats/subject`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, requestParams).then((response) => {
      return portfolioSerializer.serializePortfolioStatsBySubject(response.data);
    });
  }

  public fetchPortfolioStatsByDomain(requestParams: object = {}) {
    const endpoint = `${this.portfolioNamespace}/learner/portfolio/stats/subject/domain`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, requestParams).then((response) => {
      return portfolioSerializer.serializePortfolioStatsByDomain(response.data);
    });
  }

  public fetchPortfolioStatsByTopic(requestParams: object = {}) {
    const endpoint = `${this.portfolioNamespace}/learner/portfolio/stats/subject/domain/topic`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, requestParams).then((response) => {
      // console.log('response', response);
      return portfolioSerializer.serializePortfolioStatsByTopic(response.data);
    });
  }

  public fetchPortfolioStatsAllFacets(requestParams: object = {}) {
    const endpoint = `${this.portfolioNamespace}/learner/portfolio/stats`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, requestParams).then((response) => {
      return portfolioSerializer.serializePortfolioStatsAllFacets(response.data);
    });
  }

  public fetchIdentifiers() {
    const endpoint = `${this.identifierNamespace}/profiles/user/identities`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers).then((response) => {
      return portfolioSerializer.normalizePortfolioIdenitifier(response.data);
    });
  }

  public fetchPortfolioDetails(requestParams: any) {
    const endpoint = `${this.portfolioNamespace}/content/portfolio/item`;
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, requestParams).then((response) => {
      return portfolioSerializer.serializePortfolioDetails(response.data);
    });
  }

}

export const portfolioAPI = PortfolioAPI.instance;
